<template>
	<header class="header">
		<slot />
		<div v-if="name && canClose" class="close">
			<button @click="$modal.hide(name)" type="button" class="unbutton">
				<svg-close />
			</button>
		</div>
	</header>
</template>

<script>
export default {
	props: {
		name: {
			type: String,
			default: '',
		},
		canClose: {
			type: Boolean,
			default: true,
		},
	},
};
</script>
